// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__K3Fjs","lft":"Tabs_lft__xHrQD"};